import {useEffect, useRef} from "react";

import {IAmplitudeLeadFormProductData} from "../tracking/amplitude/get_amplitude_lead_form_products";
import {trackAmplitudeLeadFormStart} from "../tracking/amplitude/track_amplitude_lead_form_events";
import {IApplicationFormValues} from "../types/form/IApplicationFormValues";
import {IAmplitudeLeadFormTrackingContext} from "../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";

interface IUseAmplitudeLeadFormStartTrackingParams {
    trackingContext: IAmplitudeLeadFormTrackingContext | null;
    leadData: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined;
    source: ApplicationSource | null;
    sourceSection: ApplicationSourceSection | null;
    initialLeadFormValues: Pick<IApplicationFormValues, "name" | "email" | "phone"> | null | undefined;
    isReady?: boolean;
}

export const useAmplitudeLeadFormStartTracking = (params: IUseAmplitudeLeadFormStartTrackingParams) => {
    const {trackingContext, leadData, source, sourceSection, initialLeadFormValues, isReady = true} = params;
    const hasTrackedRef = useRef(false);

    useEffect(() => {
        if (!trackingContext) {
            hasTrackedRef.current = false;
            return;
        }

        if (!isReady || hasTrackedRef.current || !leadData || source == null || sourceSection == null) {
            return;
        }

        const hasAutofill = Boolean(initialLeadFormValues?.name || initialLeadFormValues?.email || initialLeadFormValues?.phone?.number);

        hasTrackedRef.current = true;

        trackAmplitudeLeadFormStart({
            trackingContext,
            leadData,
            source,
            sourceSection,
            ...(hasAutofill ? {eventAction: "autofill"} : {})
        });
    }, [initialLeadFormValues, isReady, leadData, source, sourceSection, trackingContext]);
};
import {useEffect, useRef} from "react";

import {IAmplitudeLeadFormProductData} from "../tracking/amplitude/get_amplitude_lead_form_products";
import {trackAmplitudeLeadFormStart} from "../tracking/amplitude/track_amplitude_lead_form_events";
import {IApplicationFormValues} from "../types/form/IApplicationFormValues";
import {IAmplitudeLeadFormTrackingContext} from "../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";

interface IUseAmplitudeLeadFormStartTrackingParams {
    trackingContext: IAmplitudeLeadFormTrackingContext | null;
    leadData: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined;
    source: ApplicationSource | null;
    sourceSection: ApplicationSourceSection | null;
    initialLeadFormValues: Pick<IApplicationFormValues, "name" | "email" | "phone"> | null | undefined;
    isReady?: boolean;
}

export const useAmplitudeLeadFormStartTracking = (params: IUseAmplitudeLeadFormStartTrackingParams) => {
    const {trackingContext, leadData, source, sourceSection, initialLeadFormValues, isReady = true} = params;
    const hasTrackedRef = useRef(false);

    useEffect(() => {
        if (!trackingContext) {
            hasTrackedRef.current = false;
            return;
        }

        if (!isReady || hasTrackedRef.current || !leadData || source == null || sourceSection == null) {
            return;
        }

        const hasAutofill = Boolean(initialLeadFormValues?.name || initialLeadFormValues?.email || initialLeadFormValues?.phone?.number);

        hasTrackedRef.current = true;

        trackAmplitudeLeadFormStart({
            trackingContext,
            leadData,
            source,
            sourceSection,
            ...(hasAutofill ? {eventAction: "autofill"} : {})
        });
    }, [initialLeadFormValues, isReady, leadData, source, sourceSection, trackingContext]);
};
